module.exports = __webpack_public_path__ + "img/new_terminal_mac.a3195d4c.png";